export const MIN_AGE = 18;
export const MAX_AGE = 100;

/** Age in full years, or null when the date string is invalid. */
export function getBirthdayAge(dateString: string): number | null {
  if (!dateString) return null;
  const birthDate = new Date(dateString);
  if (Number.isNaN(birthDate.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

export function isBirthdayAgeValid(dateString: string): boolean {
  const age = getBirthdayAge(dateString);
  return age !== null && age >= MIN_AGE && age <= MAX_AGE;
}

function toIsoDateLocal(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Bounds for `<input type="date">` — youngest (18+) and oldest (100) allowed birth dates. */
export function getBirthdayInputBounds(): { min: string; max: string } {
  const today = new Date();

  const max = new Date(today);
  max.setFullYear(max.getFullYear() - MIN_AGE);

  const min = new Date(today);
  min.setFullYear(min.getFullYear() - (MAX_AGE + 1));
  min.setDate(min.getDate() + 1);

  return {
    min: toIsoDateLocal(min),
    max: toIsoDateLocal(max),
  };
}

export function formatBirthdayDisplay(isoDate: string): string {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}
